module.exports = __webpack_public_path__ + "img/icon.4d1620e1.png";